export default "__VITE_ASSET__VIFC63$5__";